// Approximate centroids (lat, lng) for known US zip codes we work with.
// Extend this map as new territories are added.
export const ZIP_CENTROIDS = {
  // Maryland / DC Metro
  "20735": [38.7534, -76.8827], // Clinton, MD (MPower HQ)
  "20743": [38.8834, -76.9067], // Capitol Heights, MD
  "20744": [38.7757, -76.9670], // Fort Washington, MD
  "20747": [38.8562, -76.8845], // District Heights, MD
  "20748": [38.8007, -76.9147], // Camp Springs, MD
  "20753": [38.8065, -76.8756], // Andrews AFB area, MD
  "20745": [38.8000, -77.0080], // Oxon Hill, MD
  "20746": [38.8534, -76.9265], // Suitland, MD
  "20770": [38.9834, -76.8850], // Greenbelt, MD
  "20785": [38.9078, -76.8624], // Landover, MD
  "20852": [39.0500, -77.1200], // Rockville, MD
  "21244": [39.3487, -76.7778], // Windsor Mill, MD
  "21215": [39.3450, -76.6800], // Baltimore, MD
  "20001": [38.9124, -77.0163], // Washington, DC (NW)
  "20002": [38.9019, -76.9895], // Washington, DC (NE)
  "20003": [38.8813, -76.9908], // Washington, DC (SE)
  // NYC (seed data)
  "10001": [40.7506, -73.9971],
  "10002": [40.7157, -73.9861],
  "10003": [40.7317, -73.9891],
  "10018": [40.7549, -73.9926],
  "10019": [40.7654, -73.9846],
  "10020": [40.7594, -73.9787],
};

// Deterministic centroid: if not in map, return null so callers can fall back.
export function centroidFor(zip) {
  if (!zip) return null;
  const key = String(zip).trim().padStart(5, "0").slice(0, 5);
  return ZIP_CENTROIDS[key] || null;
}
